import { getTime, parse } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';

const parseDateString = (value: string): Date => {
  return parse(value, 'dd/MM/yyyy', new Date(), { locale: ptBR });
};

const parseTimeString = (value: string): Date => {
  return parse(value, 'HH:mm', new Date(), { locale: ptBR });
};

export const getTimestamp = (value: string): number => {
  const date = parse(value, 'P', new Date(), { locale: ptBR });

  return getTime(date);
};

export { parseDateString, parseTimeString };
